import*as r from"react";function e(e){var t=r.useRef();return t.current||(t.current={v:e()}),t.current.v}export{e as default};
//# sourceMappingURL=useConstant.js.map
